import React, {PropTypes} from 'react';
import { FormattedMessage } from 'react-intl';
import ClassNames from 'classnames';

import {serverToDisplayDate,serverToDisplayTime} from 'app/lib/format';
import {Chip} from './VisitStatus';

const VisitHeader = ({trac, visit, slotEta, slotFrom, slotTo, status, licensePlate}) => {

    let classNameDate = {
        'reg-header__date': true,
        empty: !slotEta
    };

    let classNameTimeslot = {
        'reg-header__timeslot': true,
        empty: !slotFrom
    };

    return (
        <div className="reg-header">
            <Chip status={status} />
            <div className="reg-header__visit">{visit}</div>
            <div className={ClassNames(classNameDate)}>
                {slotEta ? serverToDisplayDate(slotEta) : <FormattedMessage id="visits.overview.header.noDate" />}
            </div>
            <small className={ClassNames(classNameTimeslot)}>
                {slotFrom ? `${serverToDisplayTime(slotFrom)} - ${serverToDisplayTime(slotTo)}` : <FormattedMessage id="visits.overview.header.noTimeSlot" />}
            </small>
            <div className="reg-header__licenseplate">{licensePlate}</div>
        </div>
    );
};

VisitHeader.propTypes = {
    trac: PropTypes.string,
    visit: PropTypes.string,
    slotEta: PropTypes.string,
    slotFrom: PropTypes.string,
    slotTo: PropTypes.string,
    status: PropTypes.string,
    licensePlate: PropTypes.string
};

export default VisitHeader;
